import BaseModule from "@core/modules/base-module/base-module";
import $ from 'jquery';
import GlossaryNavigation from "@pj/components/glossary/glossary-navigation/glossary-navigation";
import whatInput from 'what-input';

let nav = null;
const glossary = new BaseModule();
glossary.name = 'glossary';
glossary.init((that) => {
  nav = new GlossaryNavigation();
  nav.init();

  let lastId = null;
  setInterval(() => {
    const id = String(window.location.href).split('#')[1];
    const $target = $(`#${id}`);
    if (($target && $target.length > 0) && lastId !== id) {
      const top = $target.offset().top - ($('.header').height() + 50);
      $('html, body').scrollTop(top);
      if (whatInput.ask() === 'keyboard') {
        $target.focus();
      }
      lastId = id;
    }
  }, 100);
});
